import * as React from "react";
import type { GatsbyBrowser } from "gatsby";
import Layout from "./src/components/Layout";
import "./src/styles/global.css";

export const wrapPageElement: GatsbyBrowser["wrapPageElement"] = ({
  element,
  props,
}) => <Layout {...props}>{element}</Layout>;

export const onRouteUpdate: GatsbyBrowser["onRouteUpdate"] = ({
  prevLocation,
}) => {
  if (!prevLocation) return; // skip initial page load

  // After navigation, force the header's scroll listener to re-evaluate
  // against the new scrollY (Gatsby's default scroll-to-top doesn't always
  // trigger the listener reliably across browsers).
  requestAnimationFrame(() => {
    window.scrollTo(0, 0);
    document.dispatchEvent(new Event("scroll"));
  });
};
